import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// @mui material components
import MDTypography from "ui/MDTypography";
import { Status } from "layouts/common/columns";
import { DetailRow } from "layouts/common/detail-page";
import { EditButton, DeleteButton } from "layouts/common/buttons";
import { DetailPageLayout } from "examples/LayoutContainers/DetailPageLayout";
import { Grid } from "@mui/material";
import centerService from "services/center-service";
const CenterDetail = () => {
  const { id } = useParams();
  const [center, setCenter] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCenter = async () => {
      const response = await centerService.get(id);
      if (response.success === true && response.center) {
        setCenter(response.center);
        console.log("response", response.center);
      }
      setLoading(false);
    };

    fetchCenter();
  }, [id]);

  const handleDelete = async (id) => {
    try {
      const response = await centerService.delete(id);
      if (response.success === true && response.center) {
        console.log("Center deleted successfully");
      } else {
        console.error("Error deleting center:", response.message);
      }
    } catch (error) {
      console.error("Error deleting center:", error);
    }
  };


  const rendercenterDetails = () => {
    if (!center) {
      return (
        <MDTypography variant="body2" color="error">
          center Not Found
        </MDTypography>
      );
    }

    const { name, centerId, email, address, city, country } = center;
    console.log("center", center);

    const centerNumber = centerId.replace(/\D/g, ''); // Remove all non-digit characters


    return (
    <Grid container spacing={2} padding={2}>
  {/* Row 1 */}
  <Grid item xs={6} md={4}>
    <DetailRow label="Center No" value={centerNumber}   className="custom-detail-row" 
 />
  </Grid>
  <Grid item xs={6} md={4}>
    <DetailRow label="Title" value={name} className="custom-detail-row" />
  </Grid>
  <Grid item xs={6} md={4}>
    <DetailRow label="Email" value={email} className="custom-detail-row" />
  </Grid>

  {/* Row 2 */}
  <Grid item xs={6} md={4}>
    <DetailRow label="Address" value={address} className="custom-detail-row" />
  </Grid>
    <Grid item xs={6} md={4}>
    <DetailRow label="City" value={city} className="custom-detail-row" />
  </Grid>
  <Grid item xs={6} md={4}>
    <DetailRow label="Country" value={country} className="custom-detail-row" />
  </Grid>

</Grid>

    );
  };


  const actionButtons = () => {
    return (
      <>
        <EditButton
          link={`/centers/${center?.id}/edit`}
        />
        {/* <DeleteButton
          clickHandler={() => handleDelete(center?.id)}
        /> */}
      </>
    );
  };

  return (
    <DetailPageLayout
      title={"Details"}
      renderContent={rendercenterDetails}
      actionButtons={actionButtons}
      backButtonRoute="/centers"
      loading={loading}
    />
  );
};

export default CenterDetail;
